/**
 * Utility to identify Good For Life (G4L) plans via planAndOptionCode.
 */
export const G4L_PLAN_CODES = [
  "51DC00",
  "51DC0010",
  "51DC001P",
  "51DC00P",
  "51DD00",
  "51DD0010",
  "51DD001P",
  "51DD00P",
  "51EN00",
  "51EN0010",
  "51EN001P",
  "51EN00P",
  "51EO00",
  "51EO0010",
  "51EO001P",
  "51EO00P",
  "5SU400",
  "5SU40010",
  "5SU4001P",
  "5SU400P",
  "5SU500",
  "5SU500P",
  "5C2L00",
  "5C3J00",
  "D3802284",
  "5C3L00",
];

export function isG4LPolicy(policy) {
  return ["AHL"].includes(policy?.blockCode);
}
